import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row, Button, Table, Dropdown, DropdownButton } from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import schoolApi from "../../api/schoolApi";
import { Link } from "react-router-dom";
import ScrollLazyLoader from "../common/ScrollLazyLoader";
import Select from "react-select";

import jsPDF from "jspdf";

import { ToastContainer, toast } from "react-toastify";
import PdfHeader from "../layout/common/PdfHeader";
import { Helmet } from "react-helmet";
import jwt_decode from "jwt-decode";
import {
  Filter,
  DatatableWrapper,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import InfoPill from "../InfoPill";
import "./reportsDetails.css";

const ReportsDetails = (props) => {
  const [classOptions, setClassOptions] = useState([]);
  const [sessionOptions, setSessionOptions] = useState([]);
  const [students, setStudents] = useState([]);
 
  const [showTable, setShowTable] = useState(false);
  const [reportData, setReportData] = useState({ classid: "", session_id: "" });
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    fetchClassRecords();
    fetchAllSessions();
  }, []);

  useEffect(() => {
    try {
      if (sessionStorage.getItem("token")) {
        let user = jwt_decode(sessionStorage.getItem("token"));
        setUserInfo(user);
      }
    } catch (error) {
     
    }
  }, []);

  const fetchClassRecords = async () => {
    try {
      const result = await schoolApi.getActiveClassRecords();
      if (result.success) {
        const options = result.result.map((item) => ({
          value: item.id,
          label: item.classname,
        }));
        setClassOptions(options);
      }
    } catch (error) {
      console.error("Error fetching class records:", error);
    }
  };

  const fetchAllSessions = async () => {
    try {
      const sessions = await schoolApi.fetchSessions();
     
      if (sessions.success) {
        const options = sessions?.result?.map((sess) => ({
          value: sess.id,
          label: sess.year,
        }));
        setSessionOptions(options);

        const currentSession = sessions?.result?.find((sess) => {
          const currentDate = new Date();
          const startDate = new Date(sess.startdate);
          const endDate = new Date(sess.enddate);
          return currentDate >= startDate && currentDate <= endDate;
        });

        if (currentSession) {
          setReportData((prevState) => ({
            ...prevState,
            session_id: currentSession.id,
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setReportData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSearch = async () => {
    if (reportData.session_id) {
      try {
       
        const result = await schoolApi.getAllStudentByClassidAndSessionid(
          reportData
        );
       
        if (result && result.message === "No record found") {
          toast.error(result.message);
          setShowTable(false);
          setStudents([]);
        } else {
          setStudents(result);
          setShowTable(true);
        }
      } catch (error) {
        console.error("Error fetching student data:", error);
        setShowTable(false);
      }
    } else {
     
      toast.error("Please fill session year");
      setShowTable(false);
      setStudents([]);
    }
  };

  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const renderPdfHeader = (doc) => {
      const logoUrl = `/${userInfo?.tenantcode}-sidebar-logo.png`;
      doc.addImage(logoUrl, "PNG", 14, 10, 27, 27);
      doc.setFontSize(18);
      doc.text(userInfo?.companyname || "Company Name", 145, 20, {
        align: "center",
      });
      doc.setFontSize(10);
      const address = `${userInfo?.companystreet}, ${userInfo?.companystate}-${userInfo?.companypincode}, ${userInfo?.companycountry}`;
      const addressLines = doc.splitTextToSize(address, 180);
      doc.text(addressLines, 145, 26, { align: "center" });
      doc.setFontSize(12);
      doc.text(`Date: ${currentDate}`, 280, 20, { align: "right" });

      doc.line(14, 40, 283, 40);
      doc.text("Student Report", 125, 47);
    };

    renderPdfHeader(doc);

    const tableData = students.map((row, index) => [
      index + 1,
      `${row?.firstname} ${row.lastname ? row.lastname : ""}`,
      `${row?.contact_firstname} ${row.contact_lastname ? row.contact_lastname : ""}`,
      `${row?.class_name || ""} ${row.section_name ? `(${row.section_name})` : ""}`,
      row?.contact_phone,
      row?.gender,
      row?.phone,
      getAddress(row),
    ]);

    doc.autoTable({
      head: [
        [
          "Sr No.",
          "Student Name",
          "Parent Name",
          "Class Name",
          "Parent Phone",
          "Gender",
          "Phone",
          "Address",
        ],
      ],
      body: tableData,
      didDrawCell: (data) => {
        doc.setLineDash([1, 1], 0);
      },

      styles: {
        borderTop: "2px solid #000",
        margin: "10px 0",
        border: 1, // General border setting for all cells
        lineWidth: 0.1, // Border thickness
        lineColor: [0, 0, 0], // Border color (Black)
        fontSize: 10,
      },
      headStyles: {
        fillColor: "rgb(41,56,70)", // Background color (RGB: Blue)
        textColor: [255, 255, 255], // Text color (White)
        halign: "center", // Center-align header text
        fontStyle: "bold", // Make text bold
      },
      columnStyles: {
        6: { halign: "" },
      },
      margin: { top: 50 },
    });

    doc.save("Student_Report.pdf");
  };

  const downloadCSV = () => {
    const headers = ["Sr No.", "Student Name", "Parent Name", "Class Name", "Parent Phone", "Gender", "Phone", "Address"];
    const csvData = students.map((row, index) => [
      index + 1,
      `"${row?.firstname} ${row.lastname || ""}"`,
      `"${row?.contact_firstname} ${row.contact_lastname || ""}"`,
      `"${row?.class_name || ""} ${row.section_name ? `(${row.section_name})` : ""}"`,
      `"${row?.contact_phone || ""}"`,
      `"${row?.gender || ""}"`,
      `"${row?.phone || ""}"`,
      `"${getAddress(row)}"`
    ]);

    const csvContent = [headers, ...csvData].map(e => e.join(",")).join("\n");
    const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, "Student_Report.csv");
  };

  const downloadExcel = () => {
    const worksheetData = students.map((row, index) => ({
      "Sr No.": index + 1,
      "Student Name": `${row?.firstname} ${row.lastname || ""}`,
      "Parent Name": `${row?.contact_firstname} ${row.contact_lastname || ""}`,
      "Class Name": `${row?.class_name || ""} ${row.section_name ? `(${row.section_name})` : ""}`,
      "Parent Phone": row?.contact_phone || "",
      "Gender": row?.gender || "",
      "Phone": row?.phone || "",
      "Address": getAddress(row),
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, "Student_Report.xlsx");
  };

  const downloadWord = () => {
    let header = "<html><head><meta charset='utf-8'></head><body>";
    let footer = "</body></html>";
    let content = `<h2 style='text-align:center;'>Student Report</h2>
      <p style='text-align:right;'>Date: ${currentDate}</p>
      <table border='1' cellspacing='0' cellpadding='5' style='width:100%; border-collapse: collapse;'>
      <tr style='background-color: #293846; color: white;'>
        <th>Sr No.</th><th>Student Name</th><th>Parent Name</th><th>Class Name</th><th>Parent Phone</th><th>Gender</th><th>Phone</th><th>Address</th>
      </tr>`;

    students.forEach((row, index) => {
      content += `<tr>
        <td style='text-align:center;'>${index + 1}</td>
        <td>${row?.firstname} ${row.lastname || ""}</td>
        <td>${row?.contact_firstname} ${row.contact_lastname || ""}</td>
        <td>${row?.class_name || ""} ${row.section_name ? `(${row.section_name})` : ""}</td>
        <td>${row?.contact_phone || ""}</td>
        <td>${row?.gender || ""}</td>
        <td>${row?.phone || ""}</td>
        <td>${getAddress(row)}</td>
      </tr>`;
    });
    content += "</table>";
    const blob = new Blob(["\ufeff" + header + content + footer], { type: 'application/msword' });
    saveAs(blob, "Student_Report.doc");
  };

  const downloadODS = () => {
    const worksheetData = students.map((row, index) => ({
      "Sr No.": index + 1,
      "Student Name": `${row?.firstname} ${row.lastname || ""}`,
      "Parent Name": `${row?.contact_firstname} ${row.contact_lastname || ""}`,
      "Class Name": `${row?.class_name || ""} ${row.section_name ? `(${row.section_name})` : ""}`,
      "Parent Phone": row?.contact_phone || "",
      "Gender": row?.gender || "",
      "Phone": row?.phone || "",
      "Address": getAddress(row),
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");
    const excelBuffer = XLSX.write(workbook, { bookType: 'ods', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.oasis.opendocument.spreadsheet' });
    saveAs(blob, "Student_Report.ods");
  };

  const handleDownload = (format) => {
    if (!students || students.length === 0) {
      toast.error("No data available to download");
      return;
    }

    switch (format) {
      case "csv":
        downloadCSV();
        break;
      case "excel":
        downloadExcel();
        break;
      case "ods":
        downloadODS();
        break;
      case "word":
        downloadWord();
        break;
      case "pdf":
      default:
        downloadPDF();
        break;
    }
  };
  const getAddress = (data) => {
    return `${data.street || ""} ${data.city || ""} ${data.state || ""} ${
      data.country || ""
    } ${data.pincode || ""}`.trim();
  };

  const labels = {
    beforeSelect: " ",
  };
  const body = students
    ? students.map((student, index) => ({
        ...student,
        serialNumber: index + 1,
        Combine_Address: student.city,
      }))
    : [];
  const headers = [
    {
      title: "Sr. No.",
      prop: "",
      width: "50px",
      cell: (row) => row.serialNumber,
      style: { textAlign: "left" },
    },

    {
      title: "Student Name",
      prop: "firstname",
      isFilterable: true,
      cell: (row) => (
        <div style={{ minWidth: "150px", wordWrap: "break-word" }}>
          {`${row.firstname} ${row.lastname ? row.lastname : ""}`}
        </div>
      ),
    },
    {
      title: "Parent Name",
      prop: "contact_firstname",
      isFilterable: true,
      cell: (row) => (
        <div style={{ minWidth: "150px", wordWrap: "break-word" }}>
          {`${row.contact_firstname} ${
            row.contact_lastname ? row.contact_lastname : ""
          }`}
        </div>
      ),
    },
    {
      title: "Class Name",
      prop: "class_name",
      isFilterable: true,
      cell: (row) => `${row.class_name} [${row.section_name}]`,
    },
    {
      title: "Parent Phone",
      prop: "contact_phone",
      isFilterable: true,
      cell: (row) => (
        <div style={{ textAlign: "right" }}>{row.contact_phone}</div>
      ),
    },
    {
      title: "Gender",
      prop: "gender",
    },
    {
      title: "Phone",
      prop: "phone",
      isFilterable: true,
      cell: (row) => <div style={{ textAlign: "right" }}>{row.phone}</div>,
    },

    { title: "Address", prop: "Combine_Address" },
  ];
  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Row className="g-0">
        <Col lg={2} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Student Report
          </Link>
        </Col>
      </Row>
      <Row className="mt-5 m-0 px-4">
        <Card className="px-0 py-3">
          <Row className="m-0">
            <Col lg={12} className="px-3">
              <h5 className="fw-semibold">Filters</h5>
            </Col>
            <hr />
          </Row>
          <Row className="flex-row mt-3 mb-2 px-4">
            <Col lg={4}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Class Name</Form.Label>
                <Form.Select
                  name="classid"
                  onChange={handleChange}
                  value={reportData.classid}
                >
                  <option key="default" value="">
                    All
                  </option>
                  {classOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Session</Form.Label>
                <Form.Select
                  name="session_id"
                  onChange={handleChange}
                  value={reportData.session_id}
                  required
                >
                  <option value="">-- Select Session --</option>
                  {sessionOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col lg={4} className="d-flex align-items-end">
              <div className="button-wrapper">
                <Button onClick={onSearch} variant="primary">
                  Search
                </Button>
              </div>
            </Col>
          </Row>
        </Card>
      </Row>
      {showTable && (
        <Row className="mt-5 m-0 px-4">
          <Card className="px-0 py-3">
            <Row className="flex-row mt-3 mb-2 px-4">
              <Col lg={12} className="p-0">
                <div id="reportContent">
                  <PdfHeader />
                  <div
                    style={{ borderTop: "2px solid #000", margin: "10px 0" }}
                  ></div>
                  <Row className="mt-2">
                    <Col lg={12} className="px-3">
                      <h5
                        style={{ textAlign: "center" }}
                        className="fw-semibold"
                      >
                        Student Report
                      </h5>
                    </Col>
                  </Row>
                </div>
                <Col lg={12} className="mt-1 px-1">
                  <DatatableWrapper
                    headers={headers}
                    body={body}
                    paginationOptionsProps={{
                      initialState: {
                        rowsPerPage: 50,
                        options: [50, 100, 200, 500, 1000],
                      },
                    }}
                  >
                    <ScrollLazyLoader maxRows={1000} step={50} />
                    <Row className="mb-4">
                      <Col
                        lg={3}
                        sm={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                      >
                        <Filter />
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        lg={5}
                        className="d-flex flex-col justify-content-start align-items-start"
                      >
                        <PaginationOptions labels={labels} />
                        <div className="mt-2">
                          <InfoPill
                            left="Total Students"
                            right={students?.length}
                          />
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        lg={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                      >
                        {students.length > 0 && (
                          <DropdownButton
                            id="dropdown-download"
                            title={
                              <span>
                                <i className="fa-solid fa-download me-2"></i>
                                Download
                              </span>
                            }
                            variant="primary"
                            className="mx-2"
                            onSelect={handleDownload}
                          >
                            <Dropdown.Item eventKey="pdf">
                              <i className="fa-solid fa-file-pdf me-2 text-danger"></i>
                              PDF Document
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="excel">
                              <i className="fa-solid fa-file-excel me-2 text-success"></i>
                              Excel Spreadsheet
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="csv">
                              <i className="fa-solid fa-file-csv me-2 text-info"></i>
                              CSV File
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="ods">
                              <i className="fa-solid fa-file-export me-2 text-warning"></i>
                              ODS Spreadsheet
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="word">
                              <i className="fa-solid fa-file-word me-2 text-primary"></i>
                              Word Document
                            </Dropdown.Item>
                          </DropdownButton>
                        )}
                      </Col>
                    </Row>
                    <Table
                      striped
                      className="transaction-report-table"
                      responsive
                      id="inventory-table-details"
                    >
                      <TableHeader />
                      {students?.length > 0 ? (
                        <TableBody />
                      ) : (
                        <TableBody>
                          <tr>
                            <td colSpan={7} className="text-center">
                              No records found
                            </td>
                          </tr>
                        </TableBody>
                      )}
                    </Table>
                    <Pagination />
                  </DatatableWrapper>
                </Col>
              </Col>
            </Row>
          </Card>
        </Row>
      )}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      ;
    </>
  );
};

export default ReportsDetails;